export default __webpack_public_path__ + "83811fad9c8406d29165b05e9ad906d1.svg";